import React from "react";
import { Link } from "react-router-dom";

const NoMatch = () => {
  return (
    <>
      <div className="notFoundContainer">
        <div className="decoration-notfound topLeft"></div>
        <div className="numberContainer">
          <p className="number">404</p>
          <p>申し訳ございません。指定されたページは存在しません。</p>
          <Link to="/">
            <button>トップページへ</button>
          </Link>
        </div>
        <div className="decoration-notfound bottomRight"></div>
      </div>
    </>
  );
};

export default NoMatch;
